export default __webpack_public_path__ + "static/fonts/BodoniW01Book.9dcf10d.woff";